<template>
  <div class="distributor-box">
    <Tabs v-model="pageParams.shelveStatus" :animated="false" class="tabs_styles" @on-click="cahngeTab">
      <TabPane v-for="item in shelveStatusList" :label="(h)=>labelRander(h, item)" :name="item.value"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter-box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <dropDownFilter
              ref="dropDownFilter"
              inputType="textarea"
              :transfer="false"
              :selectStyle="{width: '120px'}"
              :dropDownInputList="dropDownInputList"
              :defaultSelectValue="defaultSelectValue"
              @changeInput="changeInput"
              @updateInputValue="updateInputValue">
            </dropDownFilter>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000932')" prop="ymsProductCategoryIdList">
              <template v-if="isAlibabaDistributor">
                <classificationSelect ref="classificationDom" @selectValue="changeValue"></classificationSelect>
              </template>
              <template v-else>
                <vueTreeSelect
                  v-model="pageParams.ymsProductCategoryIdList"
                  :clearable="true"
                  :searchable="true"
                  :openOnFocus="true"
                  :closeOnSelect="true"
                  :noResultsText="$t('key1000102')"
                  :noOptionsText="$t('key1000375')"
                  :placeholder="$t('key1000101')"
                  :normalizer="normalizer"
                  :options="classificationData">
                  <template #option-label="{ node, labelClassName }">
                    <label
                      :class="labelClassName"
                      :title="node.label">
                      {{ node.label }}
                    </label>
                  </template>
                </vueTreeSelect>
              </template>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005725')" prop="subscriptionStatus">
              <Select v-model="pageParams.subscriptionStatus">
                <Option v-for="item in subscriptionStatusList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005726')" class="date_picker_style">
              <Date-picker
                type="datetimerange"
                :options="dateOptions"
                @on-clear="resetSubscriptionTime"
                @on-change="getSubscriptionTime"
                :clearable="true"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="subscriptionTime">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1005727')" prop="isGeneratedProduct">
              <Select v-model="pageParams.isGeneratedProduct">
                <Option v-for="item in isGeneratedProductList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <div class="flex align-items-center">
              <Select v-model="publishType" class="mr5" style="width: 110px;">
                <Option v-for="item in publishTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
              </Select>
              <template v-if="['webstorePlatformId','notWebstorePlatformId'].includes(publishType)">
                <Select v-model="pageParams.platformId" filterable>
                  <Option v-for="item in ymsPlatformAccountData" :key="item.platformId" :value="item.platformId">{{ item.platformName }}</Option>
                </Select>
              </template>
              <template v-else>
                <vueTreeSelect
                  v-model="pageParams.ymsPlatformAccountId"
                  :clearable="true"
                  :searchable="true"
                  :openOnFocus="true"
                  :closeOnSelect="true"
                  :noResultsText="$t('key1000102')"
                  :noOptionsText="$t('key1000375')"
                  :noChildrenText="$t('key1005728')"
                  :placeholder="$t('key1000101')"
                  :normalizer="setNormalizer"
                  :disable-branch-nodes="true"
                  :options="ymsPlatformAccountData">
                  <template #option-label="{ node, labelClassName }">
                    <label
                      :class="labelClassName"
                      :title="node.label">
                      {{ node.label }}
                    </label>
                  </template>
                </vueTreeSelect>
              </template>
            </div>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003367')" prop="inventoryType">
              <div class="flex align-items-center">
                <Select v-model="pageParams.inventoryType">
                  <Option v-for="item in inventoryTypeList" :key="item.value" :value="item.value">{{ item.name }}</Option>
                </Select>
                <span class="mr10 ml10">{{ '>' }}</span>
                <InputNumber :max="99999999" :min="0" :formatter="value => `${parseInt(value)}`" :placeholder="$t('key1005729')"
                  v-model="pageParams.minInventory" style="width: 250px;">
                </InputNumber>
              </div>
            </Form-item>
          </Col>
          <Col style="min-width: 170px;" push="1">
            <Button @click="reset" class="mr12">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation-box">
      <Button type="primary" class="mr15" v-if="getPermission('ymsDistributorProductInfo_product')"
        @click="generateSalesMaterialsBtn">
        {{ $t('key1005733') }}
      </Button>
      <Button type="primary" class="mr15" :disabled="selectTableData.length<=0"
        v-if="getPermission('ymsDistributorProductInfo_download')"
        @click="downProductData('all')">{{ $t('key1005734') }}
      </Button>
      <Dropdown transfer class="mr15" @on-click="batchAssociationBtn"
        v-if="getPermission('ymsDistributorProductInfo_insertCompliancePersonProducts') ||
              getPermission('ymsDistributorProductInfo_insertManufacturerProduct') ||
              getPermission('ymsDistributorMerchantSubscription_cancelSubscription') ||
              getPermission('ymsDistributorProductInfo_goodsMappingImport') ||
              getPermission('ymsDistributorProductInfo_goodsRelationImport')
      ">
        <Button type="primary">
          <span>{{ $t('key1000106') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="personInCharge"
            v-if="getPermission('ymsDistributorProductInfo_insertCompliancePersonProducts') && orderComplianceLabelVerificationTalg">
            {{ $t('key1001262') }}
          </DropdownItem>
          <DropdownItem name="manufacturer"
            v-if="getPermission('ymsDistributorProductInfo_insertManufacturerProduct') && orderComplianceLabelVerificationTalg">
            {{ $t('key1001263') }}
          </DropdownItem>
          <DropdownItem name="productAlias" v-if="getPermission('ymsDistributorProductInfo_goodsMappingImport')">
            {{ $t('key1005731') }}
          </DropdownItem>
          <DropdownItem name="productAssociationRelationship" v-if="getPermission('ymsDistributorProductInfo_goodsRelationImport')">
            {{ $t('key1005732') }}
          </DropdownItem>
          <DropdownItem name="removeFromFavorites" v-if="getPermission('ymsDistributorMerchantSubscription_cancelSubscription')">
            {{ $t('key1005735') }}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <!--列表区域-->
    <div class="table-box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="630"
        :loading="tableLoading"
        :columns="displayTableColumns"
        @on-selection-change="tableChange"
        @on-select-cancel="selectCancel"
        @on-select-all-cancel="selectAllCancel"
        :data="tableData">
      </Table>
    </div>
    <!--分页区域-->
    <div class="flex align-items-center justify-content-between">
      <div>{{ $t('key1001425') + currentlySelectedData.length + $t('key1000366') }}</div>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        class="distributor-page-box"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <publishStoreModal ref="publishStore"></publishStoreModal>
    <!--导出订单字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :exportFieldsTitle="$t('key1005702')"
      paramKeyColums="ymsProductInfoExportColumns"
      :customFieldExportList="customFieldExportList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--刊登平台弹窗-->
    <publishingPlatformModal ref="publishingPlatform" @changePlatform="changePlatform"></publishingPlatformModal>
    <!--刊登店铺弹窗-->
    <selectPublishStoreModal ref="selectPublishStore"></selectPublishStoreModal>
    <!--生成售卖资料提示弹窗-->
    <Modal v-model="generateSalesInforAlertsModal" :title="$t('key1005730')" :transfer="false"
      :mask-closable="false" @on-visible-change="generateSalesInforAlertsChange">
      <h2 v-html="generateSalesInforAlertsTitle" class="mb15"></h2>
      <RadioGroup v-model="isRegeneration">
        <Radio :label="1">{{ $t('key1002792') }}</Radio>
        <Radio :label="2">{{ $t('key1005736') }}</Radio>
      </RadioGroup>
      <template #footer>
        <Button @click="generateSalesInforAlertsModal=false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="generationBtn">{{ $t('key1005737') }}</Button>
      </template>
    </Modal>
    <!--设置别名弹窗-->
    <setAliasModal ref="setAlias"></setAliasModal>
    <!--设置关联关系弹窗-->
    <setAssociationRelationshipModal ref="setAssociationRelationship"></setAssociationRelationshipModal>
    <!--批量关联合规负责人、制造商弹窗-->
    <batchAssociationModal ref="batchAssociation" @updateData="pageParamsStatus = true"></batchAssociationModal>
    <!--单个关联合规负责人、制造商弹窗-->
    <associationOperationModal ref="associationOperation" @updateData="pageParamsStatus = true"></associationOperationModal>
    <!--导入商品别名弹窗-->
    <commonImportModal
      :modalWidth="700"
      :promptPush="1"
      :promptPushSpan="22"
      ref="importProductAlias"
      :importTitle="$t('key1005731')"
      importType="productAlias"
      fileName="excleFile"
      :uploadAction="productAliasUrl"
      @uploadSuccess="pageParamsStatus = true"
      importTemplateKey="goodsMappingTemplate">
      {{ $t('key1002622') }}<br/>
      <p v-html="importProductAliasText"></p>
      {{ $t('key1005738') }} .xIs .xIsx .csv;<br/>
    </commonImportModal>
    <!--导入商品关联关系弹窗-->
    <commonImportModal
      :modalWidth="700"
      :promptPush="1"
      :promptPushSpan="22"
      ref="importProductAssociationRelationship"
      :importTitle="$t('key1005732')"
      importType="productAlias"
      fileName="excleFile"
      :uploadAction="productAssociationRelationshipUrl"
      @uploadSuccess="pageParamsStatus = true"
      importTemplateKey="ymsProductGoodsRelationType">
      {{ $t('key1002622') }}<br/>
      <p v-html="importProductAssociationRelationshipText"></p>
      {{ $t('key1005738') }} .xIs .xIsx .csv;<br/>
    </commonImportModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {pageJump, amountHandel, isAlibabaDistributor, commonCopyContent, getCountryZoneData, setConfigCharacters, getCloudTreeData, getDataSetBatchList, getEnumList, commonLocalStorage} from "@/utils/common";
import dropDownFilter from "@/components/common/dropDownFilter";
import vueTreeSelect from '@riophae/vue-treeselect';
import exportFieldsModal from "@/components/common/exportFieldsModal.vue";
import publishStoreModal from "@/views/distributor/components/commodityManage/publishStoreModal.vue";
import selectPublishStoreModal from "@/components/common/selectPublishStoreModal.vue";
import publishingPlatformModal from "@/components/common/publishingPlatformModal.vue";
import classificationSelect from "@/components/common/classificationSelect.vue";
import setAliasModal from "@/views/distributor/components/commodityManage/setAliasModal.vue";
import setAssociationRelationshipModal from "@/views/distributor/components/commodityManage/setAssociationRelationshipModal.vue";
import batchAssociationModal from "@/components/common/batchAssociationModal.vue";
import associationOperationModal from "@/components/common/associationOperationModal.vue";
import commonImportModal from "@/components/common/commonImportModal.vue";

export default {
  name: 'commodity',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        ymsSpus: '',
        ymsSkus: '',
        cnNames: '',
        supplierMerchantIdNames: '',
        supplierMerchantIds: '',
        ymsProductCategoryIdList: null,
        platformId: null,
        ymsPlatformAccountId: null,
        subscriptionBeginTime: null,
        subscriptionEndTime: null,
        shelveStatus: '1', // 默认在售
        inventoryType: null, // 库存
        minInventory: null, // 库存下限
        isGeneratedProduct: 'null', // 售卖资料
        subscriptionStatus: 'null', // 收藏状态 0:取消收藏 1:已收藏
        pageNum: 1,
        pageSize: 100
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          key: 'select',
          align: 'left',
          fixed: 'left',
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          key: 'commodityInfo',
          align: 'left',
          minWidth: 350,
          render(h, params) {
            let name = params.row.name;
            let isPartlyStopped = params.row.isPartlyStopped;
            let list = [
              v.tableImg(h, params, 'primaryImage'),
              h('div', {
                class: 'text-align-left pl10'
              }, [
                isPartlyStopped ? h('Tag', {
                  props: {
                    color: 'error'
                  },
                  style: {
                    marginBottom: '8px'
                  }
                }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005692')) : '',
                h('Alink', {
                  props: {
                    linkName: name,
                    textAlign: 'left',
                    className: 'mb5',
                    AlinkClass: 'ellipsis_2'
                  },
                  on: {
                    AlinkBtn: () => {
                      v.toShopDetails(params.row.ymsProductId);
                    }
                  }
                }),
                h('p', {class: 'flex align-items-center'}, [
                  h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689') + params.row.ymsSpu),
                  h('Icon', {
                    props: {
                      type: 'ios-copy-outline',
                      size: 18,
                      color: '#01a6ee'
                    },
                    style: {
                      marginLeft: '10px',
                      cursor: 'pointer'
                    },
                    attrs: {
                      title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000003')
                    },
                    on: {
                      click: () => {
                        commonCopyContent(params.row.ymsSpu, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001286'));
                      }
                    }
                  })
                ]),
              ])
            ];
            return h('div', {
              class: 'flex ptb10',
            }, list);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000695'),
          key: 'skuNumber',
          minWidth: 100,
          align: 'left',
          render(h, params) {
            let skuNumber = params.row.ymsProductGoods.length || 0;
            return h('Alink', {
              props: {
                linkName: skuNumber,
                textAlign: 'left',
                className: 'themeColor',
                AlinkShow: true
              },
              on: {
                AlinkBtn: () => {
                  const {href} = v.$router.resolve({
                    path: '/viewCollectSku',
                    query: {
                      ymsProductId: params.row.ymsProductId
                    }
                  });
                  window.open(href, '_blank');
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005693'),
          key: 'ownInventory',
          align: 'left',
          minWidth: 150,
          render(h, params) {
            let distributorInTransitStock = params.row.distributorInTransitStock || 0; // 在途库存
            let distributorAvailableNumber = params.row.distributorAvailableNumber || 0; // 可用库存
            return h('div', [
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001108') + distributorInTransitStock),
              h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001109') + distributorAvailableNumber),
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001091'),
          key: 'ymsAvailableNumber',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let number = params.row.ymsAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'),
          key: 'supplierAvailableNumber',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let number = params.row.supplierAvailableNumber || 0;
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697'),
          renderHeader(h) {
            return h('div', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000697') + '(' + v.currencyState + ')');
          },
          key: 'suggestPrice',
          minWidth: 180,
          render(h, params) {
            let minSuggestPrice = amountHandel(params.row.minSuggestPrice);
            let maxSuggestPrice = amountHandel(params.row.maxSuggestPrice);
            let suggestPriceUpdatedTime = v.$uDate.dealTime(params.row.suggestPriceUpdatedTime, 'fulltime');
            let price = '-';
            if (minSuggestPrice === maxSuggestPrice) {
              price = maxSuggestPrice || '-';
            } else {
              price = minSuggestPrice + '~' + maxSuggestPrice;
            }
            return h('div', [
              h('div', price),
              suggestPriceUpdatedTime ? h('div', [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477')),
                h('p', suggestPriceUpdatedTime)
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005694'),
          key: 'quantity',
          align: 'left',
          minWidth: 140
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005695'),
          key: 'complianceResponsiblePerson',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let newList = [];
            const ymsCompliancePeoples = params.row.ymsCompliancePeoples || [];
            const zoneCodeList = [
              ...new Set(
                ymsCompliancePeoples.flatMap(p =>
                  (p.compliancePersonProductList || []).map(item => item.zoneCode)
                )
              )
            ];
            const list = v.responsibleAreaList.map(item => ({
              ...item,
              correlationStatus: zoneCodeList.includes(item.zoneCode)
            }));
            let ymsCompliancePersonIdList = ymsCompliancePeoples.flatMap(p =>
              (p.compliancePersonProductList || []).map(item => {
                return {
                  ymsCompliancePersonId: p.ymsCompliancePersonId,
                  zoneCode: item.zoneCode
                };
              })
            );
            ymsCompliancePersonIdList = [...new Set(ymsCompliancePersonIdList)];
            if (list.length > 0) {
              newList = list.map(item =>
                h('p', {class: 'flex align-items-center'}, [
                  h('span', item.name),
                  v.getPermission('ymsDistributorProductInfo_insertCompliancePersonProducts') ? h('span', {
                      class: item.correlationStatus
                        ? 'distributorThemeColor cursor'
                        : 'themeColor cursor',
                      on: {
                        click: () => {
                          v.$refs['associationOperation'].initAssociationOperationData('personInCharge',
                            params.row.ymsProductId, ymsCompliancePersonIdList);
                        }
                      }
                    },
                    item.correlationStatus ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005696') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005697')
                  ) : h('span', {
                      class: item.correlationStatus
                        ? 'distributorThemeColor'
                        : 'themeColor'
                    },
                    item.correlationStatus ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005696') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005697')
                  )
                ])
              );
            }
            return h('div', newList);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005562'),
          key: 'manufacturerInfo',
          align: 'left',
          minWidth: 160,
          render(h, params) {
            let newList = [];
            const ymsManufacturerInfos = params.row.ymsManufacturerInfos || [];
            const zoneCodeList = [
              ...new Set(
                ymsManufacturerInfos.flatMap(info =>
                  (info.ymsManufacturerInfoProductList || []).map(item => item.zoneCode)
                )
              )
            ];
            const list = v.responsibleAreaList.map(item => ({
              ...item,
              correlationStatus: zoneCodeList.includes(item.zoneCode)
            }));
            let ymsManufacturerInfoIdList = ymsManufacturerInfos.flatMap(p =>
              (p.ymsManufacturerInfoProductList || []).map(item => {
                return {
                  ymsManufacturerInfoId: p.ymsManufacturerInfoId,
                  zoneCode: item.zoneCode
                };
              })
            );
            ymsManufacturerInfoIdList = [...new Set(ymsManufacturerInfoIdList)];
            if (list.length > 0) {
              newList = list.map(item =>
                h('p', {class: 'flex align-items-center'}, [
                  h('span', item.name),
                  v.getPermission('ymsDistributorProductInfo_insertManufacturerProduct') ? h('span', {
                      class: item.correlationStatus
                        ? 'distributorThemeColor cursor'
                        : 'themeColor cursor',
                      on: {
                        click: () => {
                          v.$refs['associationOperation'].initAssociationOperationData('manufacturer',
                            params.row.ymsProductId, ymsManufacturerInfoIdList);
                        }
                      }
                    },
                    item.correlationStatus ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005696') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005697')
                  ) : h('span', {
                      class: item.correlationStatus ? 'distributorThemeColor' : 'themeColor'
                    },
                    item.correlationStatus ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005696') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005697')
                  )
                ])
              );
            }
            return h('div', newList);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005698'),
          key: 'updatedTime',
          align: 'left',
          minWidth: 170,
          sortable: true,
          render(h, params) {
            let updatedTime = v.$uDate.dealTime(params.row.updatedTime, 'fulltime');
            let shelvedTime = v.$uDate.dealTime(params.row.shelvedTime, 'fulltime');
            return h('div', [
              h('p', shelvedTime),
              shelvedTime ? h('div', [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477')),
                h('p', updatedTime)
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005699'),
          key: 'subscriptionTime',
          align: 'left',
          minWidth: 170,
          sortable: true,
          render(h, params) {
            return h('span', params.row.subscriptionTime ? v.$uDate.dealTime(params.row.subscriptionTime, 'fulltime') : '');
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005700'),
          key: 'isGeneratedProduct',
          minWidth: 150,
          render(h, params) {
            let text = '-';
            let isGeneratedProduct = params.row.isGeneratedProduct;
            v.isGeneratedProductList.map((item) => {
              if (item.value === isGeneratedProduct) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005701'),
          key: 'firstProductSalesTime',
          align: 'left',
          minWidth: 180,
          sortable: true,
          render(h, params) {
            let firstProductSalesTime = v.$uDate.dealTime(params.row.firstProductSalesTime, 'fulltime');
            let lastProductSalesTime = v.$uDate.dealTime(params.row.lastProductSalesTime, 'fulltime');
            return h('div', [
              h('p', firstProductSalesTime),
              lastProductSalesTime ? h('div', [
                h('p', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002477')),
                h('p', lastProductSalesTime)
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005667'),
          key: 'publicationStatus',
          minWidth: 130,
          align: 'left',
          render: (h, params) => {
            let onlineAccountNum = params.row.onlineAccountNum || 0;
            let allAccountNum = params.row.allAccountNum || 0;
            let allAccountList = params.row.allAccountList || [];
            return h('div', {class: 'flex align-items-center'}, [
              h('Alink', {
                props: {
                  linkName: onlineAccountNum
                },
                on: {
                  AlinkBtn: () => {
                    v.$refs['publishStore'].getPublishStoreData(allAccountList);
                  }
                }
              }),
              h('span', {class: 'mr3 ml3'}, '/'),
              h('span', allAccountNum)
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          align: 'left',
          width: 120,
          fixed: 'right',
          render(h, params) {
            let status = '';
            let subscriptionStatus = params.row.subscriptionStatus; // 1 已收藏  0 取消收藏
            let availablePlatforms = params.row.availablePlatforms && params.row.availablePlatforms.length > 0;
            let ymsProductId = params.row.ymsProductId;
            let ymsProductCategoryId = params.row.ymsProductCategoryId;
            // 1:就绪 2:处理中 3:刊登成功 4:处理失败"
            let _key = v.listingStatus === '1' ? 'listingTaskStatus' : 'listingToolTaskStatus';
            status = params.row[_key];
            let source = params.row.source;
            let platformJson = params.row.platformJson;
            let shelveStatus = params.row.shelveStatus; // 已停售的商品不支持一键刊登
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001732'),
                    show: shelveStatus !== 2 && status === 1 && availablePlatforms && v.getPermission('ymsDistributorProductInfo_publish'), // 刊登状态为待刊登的才可以一键刊登
                    clickFn: () => {
                      v.ymsProductId = ymsProductId;
                      if (source === 'listing') {
                        if (platformJson) {
                          let obj = JSON.parse(platformJson);
                          let platformIds = obj.platformIds || [];
                          v.$refs['publishingPlatform'].initPublishingPlatformData(platformIds, ymsProductCategoryId, source);
                        }
                      } else {
                        v.$refs['publishingPlatform'].initPublishingPlatformData(params.row.availablePlatforms, ymsProductCategoryId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001821'),
                    show: v.getPermission('ymsDistributorProductInfo_product'),
                    clickFn: () => {
                      v.ymsProductId = ymsProductId;
                      v.generateSalesInfoFun('single', ymsProductId, v.userInfo.merchantId, v.listingStatus);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000278'),
                    show: v.getPermission('ymsDistributorProductInfo_insertCompliancePersonProducts') &&
                    v.orderComplianceLabelVerificationTalg,
                    clickFn: () => {
                      const ymsCompliancePeoples = params.row.ymsCompliancePeoples || [];
                      let ymsCompliancePersonIdList = ymsCompliancePeoples.flatMap(p =>
                        (p.compliancePersonProductList || []).map(item => {
                          return {
                            ymsCompliancePersonId: p.ymsCompliancePersonId,
                            zoneCode: item.zoneCode
                          };
                        })
                      );
                      ymsCompliancePersonIdList = [...new Set(ymsCompliancePersonIdList)];
                      v.$refs['associationOperation'].initAssociationOperationData('personInCharge',
                        params.row.ymsProductId, ymsCompliancePersonIdList);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000279'),
                    show: v.getPermission('ymsDistributorProductInfo_insertManufacturerProduct') &&
                    v.orderComplianceLabelVerificationTalg,
                    clickFn: () => {
                      const ymsManufacturerInfos = params.row.ymsManufacturerInfos || [];
                      let ymsManufacturerInfoIdList = ymsManufacturerInfos.flatMap(p =>
                        (p.ymsManufacturerInfoProductList || []).map(item => {
                          return {
                            ymsManufacturerInfoId: p.ymsManufacturerInfoId,
                            zoneCode: item.zoneCode
                          };
                        })
                      );
                      ymsManufacturerInfoIdList = [...new Set(ymsManufacturerInfoIdList)];
                      v.$refs['associationOperation'].initAssociationOperationData('manufacturer',
                        params.row.ymsProductId, ymsManufacturerInfoIdList);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005702'),
                    show: v.getPermission('ymsDistributorProductInfo_download'),
                    clickFn: () => {
                      v.ymsProductId = ymsProductId;
                      v.exportType = 'single';
                      v.downProductData('single', ymsProductId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005703'),
                    show: subscriptionStatus === 1 && v.getPermission('ymsDistributorMerchantSubscription_cancelSubscription'),
                    clickFn: () => {
                      v.ymsProductId = ymsProductId;
                      v.unSubscription([ymsProductId]);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005704'),
                    show: status === 4 && availablePlatforms && v.getPermission('ymsDistributorProductInfo_publish'),
                    clickFn: () => {
                      v.ymsProductId = ymsProductId;
                      if (source === 'listing') {
                        if (platformJson) {
                          let obj = JSON.parse(platformJson);
                          let platformIds = obj.platformIds || [];
                          v.$refs['publishingPlatform'].initPublishingPlatformData(platformIds, ymsProductCategoryId, source);
                        }
                      } else {
                        v.$refs['publishingPlatform'].initPublishingPlatformData(params.row.availablePlatforms, ymsProductCategoryId);
                      }
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005670'),
                    show: v.getPermission('ymsProductGoodsMapping_saveAlias'),
                    clickFn: () => {
                      let ymsProductGoods = params.row.ymsProductGoods || [];
                      let ymsProductGoodsIdList = ymsProductGoods.filter(item => item.ymsProductGoodsId).map(item => item.ymsProductGoodsId);
                      v.$refs['setAlias'].initSetAliasData(ymsProductGoodsIdList);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005705'),
                    show: v.getPermission('ymsProductGoodsPlatformMapping_saveRelation'),
                    clickFn: () => {
                      let ymsProductGoods = params.row.ymsProductGoods || [];
                      let ymsProductGoodsIdList = ymsProductGoods.filter(item => item.ymsProductGoodsId).map(item => item.ymsProductGoodsId);
                      v.$refs['setAssociationRelationship'].initSetAssociationRelationshipData(ymsProductGoodsIdList);
                    }
                  },
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.optionBtnWidth = [];
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      selectTableData: [],
      subscriptionTime: [],
      dropDownInputList: [
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000714'), value: 1, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005706'), parameterKey: 'ymsSpus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005707'), value: 2, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005708'), parameterKey: 'ymsSkus'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001099'), value: 3, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005709'), parameterKey: 'cnNames'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001101'), value: 4, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005710'), parameterKey: 'supplierMerchantIdNames'},
        {title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002805'), value: 5, placeholder: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005711'), parameterKey: 'supplierMerchantIds'},
      ],
      defaultSelectValue: 1,
      exportType: 'all', // 默认批量导出
      currentlySelectedData: [], // 记录当前选中的数据
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005712'),
          titleKey: 'commodityBasicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {paramKey: 'isCommodityInformation', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005713'), disabledDrag: true},
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005714'),
          titleKey: 'commodityPictureColums',
          selectList: [], // 选中导出字段的key carousel：轮播图 attribute：属性图 sizeTable：尺码表
          checkBoxList: [
            {paramKey: 'carousel', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005715'), disabledDrag: true},
            {paramKey: 'attribute', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005716'), disabledDrag: true},
            {paramKey: 'sizeTable', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000978'), disabledDrag: true}
          ]
        }
      ],
      ymsProductId: null,
      labelRander: (h, params) => {
        let total = params.total || 0;
        return h('div', {class: 'flex align-items-center'}, [
          h('span', params.title),
          h('span', `(${total})`),
        ]);
      },
      shelveStatusList: [
        {value: 'null', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), total: 0},
        {value: '1', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001112'), total: 0},
        {value: '2', title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000539'), total: 0},
      ],
      inventoryTypeList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004662'), value: 0},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001091'), value: 2},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001102'), value: 1},
      ],
      generateSalesInforAlertsModal: false,
      isRegeneration: 1,
      generationTalg: false,
      generatedList: [],
      generateSalesInforAlertsTitle: '',
      classificationData: [],
      responsibleAreaList: [],
      ymsPlatformAccountData: [],
      setNormalizer(node) {
        return {
          id: node.id,
          label: node.label,
          children: node.children,
          disabled: node.disabled || false
        };
      },
      publishType: 'webstorePlatformId',
      publishTypeList: [
        {value: 'webstorePlatformId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005717')},
        {value: 'webstoreYmsPlatformAccountId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005718')},
        {value: 'notWebstorePlatformId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005719')},
        {value: 'notWebstoreYmsPlatformAccountId', name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005720')},
      ],
      productAliasUrl: api.post_ymsDistributorProductInfo_goodsMappingImport,
      productAssociationRelationshipUrl: api.post_ymsDistributorProductInfo_goodsRelationImport,
      enumData: [],
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    /**
     * 0:YMS上架工具 1:通途刊登系统
     * 刊登类型为1 展示listingTaskStatus状态
     刊登类型为0 展示listingToolTaskStatus状态
     * */
    listingStatus() {
      return this.$store.state.erpConfig.merchant.listingStatus;
    },
    filterKeyList() {
      let parameterKeyList = this.dropDownInputList.map((item) => {
        return item.parameterKey;
      });
      return parameterKeyList;
    },
    // 判断是否是阿里分销商
    isAlibabaDistributor() {
      return isAlibabaDistributor();
    },
    // 导入商品别名提示文案
    importProductAliasText() {
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005677')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005678')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005679')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005680')}<br/>
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005681')}<br/>`;
    },
    // 导入商品关联关系提示文案
    importProductAssociationRelationshipText() {
      return `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005682')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005683')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005684')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005685')}
              ${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005686')}<br/>
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005687')}
              ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005688')}<br/>`;
    },
    // 售卖资料状态
    isGeneratedProductList() {
      const ENUM_KEY = 'YmsMerchantSubscriptionIsGeneratedProductCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 收藏状态
    subscriptionStatusList() {
      const ENUM_KEY = 'YmsMerchantSubscriptionStatusCoreEnum';
      let list = getEnumList(this.enumData, ENUM_KEY, 'number');
      list.unshift({
        value: 'null',
        name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
      });
      return list;
    },
    // 订单合规标签校验配置项是否开启
    orderComplianceLabelVerificationTalg() {
      const saasConfigurationItems = commonLocalStorage.getItem('saasConfigurationItems') ?? this.$store.state.saasConfigurationItems;
      return Number(saasConfigurationItems?.orderComplianceLabelVerificationSaas) === 1;
    },
    // 按合规标签配置过滤列表展示列
    displayTableColumns() {
      if (this.orderComplianceLabelVerificationTalg) {
        return this.tableColumns;
      }
      return this.tableColumns.filter((item) => {
        return !['complianceResponsiblePerson', 'manufacturerInfo'].includes(item.key);
      });
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = [
          'YmsMerchantSubscriptionIsGeneratedProductCoreEnum',
          'YmsMerchantSubscriptionStatusCoreEnum'
        ];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await v.getProductsTotal();
        await v.getCloudSalesClassification();
        await v.getPlatformStoreAllData();
        await getCountryZoneData().then((data) => {
          v.responsibleAreaList = data;
        });
        await v.search();
      })();
    },
    // 分类筛选
    changeValue(value) {
      this.pageParams.ymsProductCategoryIdList = value;
    },
    // 获取分类的数据
    getCloudSalesClassification() {
      let v = this;
      if (isAlibabaDistributor()) {
        getCloudTreeData(api.distributor_post_ymsProductCategory_shopping_queryForExistsProduct, 'tile').then((data) => {
          v.$nextTick(() => {
            v.$refs['classificationDom'].initClassificationData(data);
          });
        });
      } else {
        setTimeout(() => {
          getCloudTreeData(api.distributor_post_ymsProductCategory_shopping_queryForExistsProduct).then((data) => {
            v.classificationData = data;
          });
        }, 2000);
      }
    },
    // 获取所有平台店铺数据
    getPlatformStoreAllData() {
      this.ymsPlatformAccountData = [];
      return new Promise((resolve, reject) => {
        let obj = {
          platformIds: [],
          platformType: "sales",
        };
        this.axios.post(api.post_ymsPlatform_api_query, obj).then((response) => {
          if (response.data.code === 0) {
            let platformData = response.data.datas || [];
            let platformIdList = [];
            if (platformData.length > 0) {
              platformIdList = platformData.map(item => item.platformId);
            }
            let query = {
              code: '',
              platformIds: platformIdList,
              status: 1, // 已启用
            };
            this.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountList, query).then(response => {
              if (response.data.code === 0) {
                let data = response.data.datas || [];
                const tree = {};
                let newData = [];
                platformData.map((item) => {
                  let {name, platformId} = item;
                  let obj = {};
                  data.map((ele) => {
                    if (item.platformId === ele.platformId) {
                      obj = JSON.parse(JSON.stringify(ele));
                    }
                  });
                  newData.push({
                    platformId,
                    platformName: name,
                    ...obj
                  });
                });
                newData.forEach(item => {
                  const {platformId, ymsPlatformAccountId, name, code, platformName, ...platformInfo} = item;
                  if (!tree[platformId]) {
                    tree[platformId] = {
                      platformId,
                      platformName,
                      ...platformInfo,
                      children: [],
                      id: platformId,
                      label: platformName,
                      disabled: true
                    };
                  }
                  if (item.ymsPlatformAccountId) {
                    tree[platformId].children.push({
                      id: ymsPlatformAccountId,
                      label: name,
                      code
                    });
                  }
                });
                let newList = Object.values(tree);
                this.ymsPlatformAccountData = newList || [];
                resolve(newList);
              }
            });
          }
        });
      });
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.pageParams.minInventory = null;
      if (v.$refs['classificationDom']) {
        v.$refs['classificationDom'].reset();
      }
      v.subscriptionTime = [];
      v.resetSubscriptionTime();
      v.selectTableData = [];
      v.publishType = 'webstorePlatformId';
      v.pageParams.platformId = null;
      v.pageParams.ymsPlatformAccountId = null;
      v.changeInput(1);
    },
    // 处理参数
    handleParameter() {
      let v = this;
      let {platformId, ymsPlatformAccountId, ...obj} = v.pageParams;
      let params = Object.assign({}, obj);
      for (let key in params) {
        if (v.filterKeyList.includes(key)) {
          params[key] = v.sepCommasFn(params[key], ['\n']);
        }
      }
      params.ymsProductCategoryIdList = v.pageParams.ymsProductCategoryIdList ? [v.pageParams.ymsProductCategoryIdList] : [];
      let keyList = ['shelveStatus', 'isGeneratedProduct', 'subscriptionStatus'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : Number(v.pageParams[key]);
      }
      if (!v.pageParams.inventoryType && v.pageParams.inventoryType !== 0) {
        params.inventoryType = null;
      }
      // 处理已刊登、未刊登平台店铺的参数
      this.publishTypeList.map((item) => {
        params[item.value] = null;
        if (item.value === v.publishType) {
          if (['webstorePlatformId', 'notWebstorePlatformId'].includes(v.publishType)) {
            params[item.value] = platformId;
          } else {
            params[item.value] = ymsPlatformAccountId;
          }
        }
      });
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      if (v.getPermission('ymsDistributorProductInfo_query')) {
        v.optionBtnWidth = [];
        v.tableData = [];
        v.selectTableData = [];
        let ymsPlatformAccountIds = [];
        v.tableLoading = true;
        v.axios.post(api.post_ymsDistributorProductInfo_query, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas.list || [];
            if (data.length > 0) {
              data.map((item) => {
                item.maxSuggestPrice = amountHandel(item.maxSuggestPrice);
                item.minSuggestPrice = amountHandel(item.minSuggestPrice);
                if (item.ymsProductListingDetails && item.ymsProductListingDetails.length > 0) {
                  item.ymsProductListingDetails.map((ele) => {
                    ymsPlatformAccountIds.push({
                      ymsPlatformAccountId: ele.ymsPlatformAccountId
                    });
                  });
                }
                const goods = item.ymsProductGoods || [];
                let isPartlyStopped = goods.length > 0 && goods.some(g => g.status === 2) && !goods.every(g => g.status === 2);
                item.isPartlyStopped = isPartlyStopped;
              });
              v.getListingCommodityData(data).then((newData) => {
                v.getStoreCode(newData, ymsPlatformAccountIds);
              });
            } else {
              v.tableLoading = false;
            }
            v.total = response.data.datas.total;
          }
        }).catch(() => {
          v.tableLoading = false;
        });
      } else {
        v.gotoError();
      }
    },
    // 获取商品listing刊登的数据
    getListingCommodityData(newData) {
      let v = this;
      return new Promise((resolve) => {
        let query = {
          productIdList: newData.map((item) => {
            return item.ymsProductId;
          })
        };
        v.axios.post(api.post_ymsDistributorProductInfo_queryProductListingAccount, query).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas || [];
            if (data.length > 0) {
              let newList = JSON.parse(JSON.stringify(newData));
              newList.map((item) => {
                data.map((ele) => {
                  if (item.ymsProductId === ele.ymsProductId) {
                    item.allAccountList = ele.allAccountList;
                    item.allAccountNum = ele.allAccountNum;
                    item.onlineAccountNum = ele.onlineAccountNum;
                  }
                });
              });
              resolve(newList);
            } else {
              resolve(newData);
            }
          } else {
            v.tableLoading = false;
          }
        });
      });
    },
    // 根据ymsPlatformAccountId获取对应店铺的code
    getStoreCode(data, ymsPlatformAccountIds) {
      let v = this;
      let ymsPlatformAccountIdList = v.uniqueFunc(ymsPlatformAccountIds, 'ymsPlatformAccountId').map(i => i.ymsPlatformAccountId);
      if (ymsPlatformAccountIdList.length > 0) {
        v.axios.post(api.post_ymsPlatformAccount_queryYmsPlatformAccountByIds, ymsPlatformAccountIdList).then(response => {
          if (response.data.code === 0) {
            let datas = response.data.datas;
            if (datas) {
              datas.map((item) => {
                data.map((ele) => {
                  if (ele.ymsProductListingDetails && ele.ymsProductListingDetails.length > 0) {
                    ele.ymsProductListingDetails.map((talg) => {
                      if (talg.ymsPlatformAccountId === item.ymsPlatformAccountId) {
                        talg['code'] = item.code;
                        talg['name'] = item.name;
                      }
                    });
                  }
                });
              });
              v.tableData = data;
              updateDom();
              v.recordSelectGoods(v.tableData);
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.tableData = data || [];
        updateDom();
        v.recordSelectGoods(v.tableData);
      }

      function updateDom() {
        v.$nextTick(() => {
          v.tableLoading = false;
        });
        if (v.tableData.length > 0) {
          v.$nextTick(() => {
            setTimeout(() => {
              if (v.$refs['selection']) {
                v.$refs['selection'].$el.querySelector('.ivu-table-body').scrollTop = 0;
              }
              v.optionBtnWidth = [];
              v.tableData = [...v.tableData];
            }, 2000);
          });
          setTimeout(() => {
            v.tableData = [...v.tableData];
            v.$forceUpdate();
          }, 1000);
          v.$forceUpdate();
        }
      }
    },
    // 下载资料
    downProductData(type, ymsProductId) {
      let v = this;
      let ymsProductIds = [];
      if (type === 'single') {
        ymsProductIds = [ymsProductId];
      } else if (type === 'all') {
        ymsProductIds = v.currentlySelectedData.map((item) => {
          return item.ymsProductId;
        });
      }
      if (ymsProductIds.length <= 0) {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005542'));
        return false;
      } else {
        if (ymsProductIds.length <= 10) {
          v.$refs['exportFields'].getExportFieldsSetting();
        } else {
          v.$Modal.warning({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005721'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005722'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000732')
          });
        }
      }
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = {
        commodityPictures: [],
        isCommodityInformation: 0,
        ymsProductIds: []
      };
      let ymsProductIds = [];
      if (v.exportType === 'single') {
        ymsProductIds = [v.ymsProductId];
      } else if (v.exportType === 'all') {
        ymsProductIds = v.currentlySelectedData.map((item) => {
          return item.ymsProductId;
        });
      }
      query.ymsProductIds = ymsProductIds;
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let paramValue = data.paramValue || '';
          if (paramValue) {
            let keyObj = JSON.parse(paramValue);
            let commodityBasicInfoColums = keyObj['commodityBasicInfoColums'] || [];
            if (commodityBasicInfoColums.length > 0) {
              commodityBasicInfoColums.map((item) => {
                if (item.isChoose === '1') {
                  query.isCommodityInformation = 1;
                } else {
                  query.isCommodityInformation = 0;
                }
              });
            }
            let commodityPictureColums = keyObj['commodityPictureColums'] || [];
            if (commodityPictureColums.length > 0) {
              commodityPictureColums.map((ele) => {
                if (ele.isChoose === '1') {
                  query.commodityPictures.push(ele.columnName);
                }
              });
            }
            v.axios.post(api.post_ymsDistributorProductInfo_download, query, {
              loading: true,
              loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
            }).then(response => {
              if (response.data.code === 0) {
                let taskNumber = response.data.datas;
                v.exportType = 'all';
                v.ymsProductId = null;
                v.$refs['exportFields'].exportFieldsModal = false;
                setTimeout(() => {
                  pageJump('/distributor.html#/exportTask?operateCode=' + taskNumber, '/yms-distributor-service', '_blank');
                }, 30);
              }
            });
          }
        }
      });
    },
    // 取消收藏
    unSubscription(ymsProductIds) {
      let v = this;
      v.axios.post(api.post_ymsDistributorMerchantSubscription_cancelSubscription, ymsProductIds,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
          v.pageParamsStatus = true;
        }
      });
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data.length > 0) {
        this.selectTableData = data;
      }
    },
    // 取消选中的数据
    selectCancel(selection, row) {
      let v = this;
      let ymsProductId = row.ymsProductId;
      v.currentlySelectedData.map((item, index) => {
        if (item.ymsProductId === ymsProductId) {
          v.currentlySelectedData.splice(index, 1);
        }
      });
    },
    // 全部取消选中的数据
    selectAllCancel(selection) {
      if (selection.length <= 0) {
        let ymsProductIds = this.tableData.map((ele) => {
          return ele.ymsProductId;
        });
        if (ymsProductIds.length > 0) {
          let newList = this.currentlySelectedData.filter((item) => {
            if (!ymsProductIds.includes(item.ymsProductId)) {
              return item;
            }
          });
          this.currentlySelectedData = newList;
        }
      }
    },
    // 跨页记录已勾选的商品
    recordSelectGoods(data) {
      let v = this;
      let list = [...v.selectTableData, ...v.currentlySelectedData];
      if (data && data.length > 0) {
        this.currentlySelectedData = this.uniqueFunc(list, 'ymsProductId');
        data.map((item, index) => {
          v.currentlySelectedData.map((ele) => {
            if (item.ymsProductId === ele.ymsProductId) {
              v.$set(data[index], '_checked', true);
              v.$forceUpdate();
            }
          });
        });
      }
    },
    // 选择刊登平台之后
    changePlatform(data) {
      let type = Number(this.listingStatus);
      this.$refs['selectPublishStore'].initSelectPublishStoreData(data, this.ymsProductId, type);
    },
    // 选取收藏时间
    getSubscriptionTime(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (!value[0]) {
          v.pageParams.subscriptionBeginTime = null;
          v.pageParams.subscriptionEndTime = null;
        } else {
          let timeList = v.defaultTimePeriod(value);
          v.subscriptionTime = v.defaultTimePeriod(value, false);
          v.pageParams.subscriptionBeginTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.subscriptionEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置收藏时间
    resetSubscriptionTime() {
      this.pageParams.subscriptionBeginTime = null;
      this.pageParams.subscriptionEndTime = null;
    },
    // 获取下拉选项筛选条件的值
    updateInputValue(data) {
      this.pageParams[data.key] = data.value;
    },
    // 改变默认下拉选项的值
    changeInput(value) {
      this.defaultSelectValue = value;
      if (this.$refs.dropDownFilter) {
        this.$refs.dropDownFilter.inputValue = '';
      }
      this.dropDownInputList.map((item) => {
        if (Object.keys(this.pageParams).includes(item.parameterKey)) {
          this.pageParams[item.parameterKey] = '';
        }
      });
    },
    // 获取销售状态下的商品总数
    getProductsTotal() {
      let v = this;
      let ymsDistributorMerchantId = v.userInfo.merchantId;
      v.axios.get(api.get_ymsMerchantSubscription_api_queryDifferentStateCount + ymsDistributorMerchantId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              v.shelveStatusList.map((ele) => {
                if (item.shelveStatus === Number(ele.value)) {
                  ele.total = item.countTotal;
                } else if (ele.value === 'null') {
                  const total = data.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.countTotal;
                  }, 0);
                  ele.total = total;
                }
              });
            });
            v.$forceUpdate();
          }
        }
      });
    },
    // 切换tab 栏
    cahngeTab(name) {
      this.pageParams.pageNum = 1;
      this.currentlySelectedData = [];
      this.pageParamsStatus = true;
    },
    // 判断批量生成售卖资料
    generateSalesMaterialsBtn() {
      let v = this;
      v.generatedList = [];
      v.generateSalesInforAlertsTitle = '';
      if (v.currentlySelectedData.length > 0) {
        v.generatedList = v.currentlySelectedData.filter((item) => {
          return item.isGeneratedProduct === 1;
        });
        if (v.generatedList.length > 0) {
          v.generateSalesInforAlertsModal = true;
          v.generateSalesInforAlertsTitle = `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005689')}${v.currentlySelectedData.length}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005690')}<span class="distributorThemeColor ml2 mr2">${v.generatedList.length}</span>${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005691')}`;
        } else {
          v.generateSalesInforAlertsModal = false;
          v.generationTalg = false;
          v.generateSalesInfoFun('all', null, v.userInfo.merchantId, v.listingStatus, v.currentlySelectedData);
        }
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000160'));
        return false;
      }
    },
    // 监听生成售卖资料弹窗
    generateSalesInforAlertsChange(val) {
      if (!val) {
        this.isRegeneration = 1;
        this.generationTalg = false;
      }
    },
    // 批量生成售卖资料
    generationBtn() {
      this.generationTalg = true;
      this.generateSalesInfoFun('all', null, this.userInfo.merchantId, this.listingStatus, this.currentlySelectedData);
    },
    // 批量操作
    batchAssociationBtn(value) {
      if (['productAlias', 'productAssociationRelationship'].includes(value)) {
        switch (value) {
          // 导入商品别名
          case 'productAlias':
            this.$refs['importProductAlias'].importModal = true;
            break;
          // 导入商品关联关系
          case 'productAssociationRelationship':
            this.$refs['importProductAssociationRelationship'].importModal = true;
            break;
        }
      } else {
        if (this.currentlySelectedData.length > 0) {
          switch (value) {
            // 批量关联合规负责人、关联制造商
            case 'personInCharge':
            case 'manufacturer':
              let ymsProductIds = this.currentlySelectedData.map((item) => {
                return item.ymsProductId;
              });
              this.$refs['batchAssociation'].initBatchAssociationData(value, ymsProductIds);
              break;
            // 批量取消收藏
            case 'removeFromFavorites':
              let list = this.currentlySelectedData.filter((item) => item.subscriptionStatus === 1);
              if (list.length > 0) {
                let ymsProductIds = list.map((item) => {
                  return item.ymsProductId;
                });
                this.unSubscription(ymsProductIds);
              } else {
                this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005723'));
                return false;
              }
              break;
          }
        } else {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005724'));
          return false;
        }
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
    // 监听选中的数据
    selectTableData: {
      handler(data) {
        let v = this;
        if (data.length > 0) {
          let list = [...v.currentlySelectedData, ...data];
          v.currentlySelectedData = v.uniqueFunc(list, 'ymsProductId');
        }
      },
      immediate: true,
      deep: true
    },
    publishType: {
      handler(value) {
        this.pageParams.platformId = null;
        this.pageParams.ymsPlatformAccountId = null;
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    commonImportModal,
    classificationSelect,
    publishingPlatformModal,
    selectPublishStoreModal,
    exportFieldsModal,
    dropDownFilter,
    vueTreeSelect,
    publishStoreModal,
    setAliasModal,
    setAssociationRelationshipModal,
    batchAssociationModal,
    associationOperationModal
  }
};
</script>

<style lang="less">
.commodity-operation {
  margin-bottom: 0;
}

.publicationRecord_box_style {
  z-index: 1110 !important;

  .ivu-poptip-body {
    padding: 0;
  }
}
</style>
<style lang="less" scoped>
.listing-setting {
  cursor: pointer;
  line-height: 32px;
}

.alert-listing-setting {
  border: 1px solid #abdcff;
  background-color: #f0faff;
  padding: 7px;
  border-radius: 4px;
  color: #515a6e;
  font-size: 12px;
  line-height: 16px;
  margin-right: 10px;
}
</style>
